if (!customElements.get('rougemont-order')) {
  customElements.define('rougemont-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.product = JSON.parse(this.querySelector('[data-rgm-product]').textContent);
      this.words = JSON.parse(this.querySelector('[data-rgm-text]').textContent);
      this.rows = this.querySelector('.rgm__rows');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('.rgm__submit');
      this.error = this.querySelector('.rgm__error');
      this.sequence = 0;
      this.money = new Intl.NumberFormat('en-GB', {style: 'currency', currency: 'GBP'});
      this.colourIndex = this.product.options.findIndex(x => /colou?r/i.test(typeof x === 'string' ? x : x.name));
      this.sizeIndex = this.product.options.findIndex(x => /size/i.test(typeof x === 'string' ? x : x.name));
      this.querySelector('.rgm__add').addEventListener('click', () => this.addRow(true));
      this.form.addEventListener('submit', event => this.submit(event));
      this.querySelectorAll('[data-rgm-image]').forEach(button => button.addEventListener('click', () => this.showImage(button.dataset.rgmImage, button.dataset.rgmAlt)));
      this.vatToggle = document.querySelector('#vat-toggle-checkbox');
      this.onVatChange = () => this.total();
      this.vatToggle?.addEventListener('change', this.onVatChange);
      document.addEventListener('DOMContentLoaded', this.onVatChange, {once: true});
      this.addRow(false);
    }
    disconnectedCallback() {
      this.vatToggle?.removeEventListener('change', this.onVatChange);
      document.removeEventListener('DOMContentLoaded', this.onVatChange);
    }
    includesVat() {
      if (this.vatToggle) return this.vatToggle.checked;
      try { return localStorage.getItem('vat_included') !== 'false'; } catch { return true; }
    }
    element(tag, className, text) {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text) el.textContent = text;
      return el;
    }
    control(row, labelText, key, tag) {
      const label = this.element('label', 'rgm__field rgm__field--' + key);
      label.append(this.element('span', '', labelText));
      const input = this.element(tag);
      input.dataset.field = key;
      input.id = 'rgm-' + this.dataset.section + '-' + this.sequence + '-' + key;
      label.htmlFor = input.id;
      input.required = true;
      label.append(input);
      row.append(label);
      return input;
    }
    addRow(focus) {
      if (this.rows.children.length >= 20) return;
      this.sequence++;
      const row = this.element('fieldset', 'rgm__row');
      row.append(this.element('legend'));
      const colour = this.control(row, this.words.colour, 'colour', 'select');
      [...new Set(this.product.variants.map(v => v.options[this.colourIndex]))].forEach(c => colour.add(new Option(c, c)));
      this.control(row, this.words.size, 'size', 'select');
      const quantity = this.control(row, this.words.quantity, 'quantity', 'input');
      quantity.type = 'number'; quantity.min = '1'; quantity.max = '99'; quantity.step = '1'; quantity.value = '1'; quantity.inputMode = 'numeric';
      const name = this.control(row, this.words.name, 'name', 'input');
      name.type = 'text'; name.maxLength = 40; name.placeholder = this.words.placeholder; name.autocomplete = 'off';
      name.addEventListener('input', () => name.setCustomValidity(name.value.trim() && !/[<>\r\n]/.test(name.value) ? '' : this.words.required));
      const remove = this.element('button', 'rgm__remove', this.words.remove);
      remove.type = 'button';
      remove.addEventListener('click', () => {
        if (this.rows.children.length === 1) return;
        row.remove(); this.refreshRows(); this.total();
        this.rows.lastElementChild.querySelector('select').focus();
      });
      row.append(remove);
      colour.addEventListener('change', () => { this.sizes(row); this.updateImage(row); this.total(); });
      row.addEventListener('input', () => { this.total(); this.querySelector('.rgm__confirm input').checked = false; });
      row.addEventListener('change', () => { this.total(); this.querySelector('.rgm__confirm input').checked = false; });
      this.rows.append(row); this.sizes(row); this.refreshRows(); this.total();
      this.querySelector('.rgm__confirm input').checked = false;
      if (focus) colour.focus();
    }
    refreshRows() {
      Array.from(this.rows.children).forEach((row, i) => {
        row.querySelector('legend').textContent = this.words.garment + ' ' + (i + 1);
        row.querySelector('.rgm__remove').disabled = this.rows.children.length === 1;
      });
      this.querySelector('.rgm__add').disabled = this.rows.children.length >= 20;
    }
    sizes(row) {
      const colour = row.querySelector('[data-field="colour"]').value;
      const select = row.querySelector('[data-field="size"]');
      const previous = select.value;
      select.replaceChildren();
      this.product.variants.filter(v => v.options[this.colourIndex] === colour).forEach(v => {
        const opt = new Option(v.options[this.sizeIndex] + (v.available ? '' : ' — ' + this.words.unavailable), v.options[this.sizeIndex]);
        opt.disabled = !v.available;
        select.add(opt);
      });
      const choice = Array.from(select.options).find(o => o.value === previous && !o.disabled) || Array.from(select.options).find(o => !o.disabled);
      if (choice) select.value = choice.value;
      else select.selectedIndex = -1;
    }
    variant(row) {
      const colour = row.querySelector('[data-field="colour"]').value;
      const size = row.querySelector('[data-field="size"]').value;
      return this.product.variants.find(v => v.options[this.colourIndex] === colour && v.options[this.sizeIndex] === size);
    }
    total() {
      let total = 0; let taxable = false;
      const incVat = this.includesVat();
      Array.from(this.rows.children).forEach(row => {
        const v = this.variant(row);
        const qty = Number(row.querySelector('[data-field="quantity"]').value);
        if (v && Number.isInteger(qty) && qty > 0 && qty <= 99) {
          total += Math.round(v.price * (v.taxable && incVat ? 1 + Number(this.dataset.vatRate) / 100 : 1)) * qty;
          taxable ||= v.taxable;
        }
      });
      this.querySelector('[data-rgm-total]').textContent = this.money.format(total / 100);
      this.querySelector('[data-rgm-tax]').textContent = taxable ? (incVat ? this.words.incVat : this.words.exVat) : this.words.noVat;
      const first = this.rows.firstElementChild;
      const variant = first && this.variant(first);
      const price = this.querySelector('.rgm__price');
      if (variant && price) {
        const amount = variant.price * (variant.taxable && incVat ? 1 + Number(this.dataset.vatRate) / 100 : 1);
        price.querySelector('strong').textContent = this.money.format(Math.round(amount) / 100);
        price.querySelector('span').textContent = variant.taxable ? (incVat ? this.words.incVat : this.words.exVat) : this.words.noVat;
        const secondary = price.querySelector('small');
        if (secondary) secondary.hidden = true;
      }
    }
    showImage(src, alt) {
      const hero = this.querySelector('.rgm__hero');
      if (!hero || !src) return;
      hero.removeAttribute('srcset'); hero.src = src; hero.alt = alt || '';
      this.querySelectorAll('[data-rgm-image]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.rgmImage.split('?')[0] === src.split('?')[0])));
    }
    updateImage(row) {
      const v = this.variant(row);
      if (v?.featured_image?.src) this.showImage(v.featured_image.src, v.featured_image.alt || this.product.title);
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      this.error.hidden = true;
      const rows = Array.from(this.rows.children);
      rows.forEach(row => {
        const input = row.querySelector('[data-field="name"]');
        input.value = input.value.trim();
        input.setCustomValidity(input.value && !/[<>\r\n]/.test(input.value) ? '' : this.words.required);
      });
      if (!this.form.reportValidity()) return;
      const items = [];
      for (const row of rows) {
        const v = this.variant(row);
        if (!v || !v.available) { this.error.textContent = this.words.unavailable; this.error.hidden = false; return; }
        items.push({id: v.id, quantity: Number(row.querySelector('[data-field="quantity"]').value), properties: {
          'Name on back': row.querySelector('[data-field="name"]').value,
          'Front print': 'Oliver! — left breast',
          'Back print': 'Personalised name — gold',
          'School / production': 'Rougemont — Oliver!'
        }});
      }
      this.busy = true; this.submitButton.disabled = true; this.submitButton.textContent = this.words.adding; this.form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.cartAddUrl, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(data.description || this.words.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.error.textContent = error.message || this.words.error;
        this.error.hidden = false;
        this.busy = false; this.submitButton.disabled = false; this.submitButton.textContent = this.words.add; this.form.removeAttribute('aria-busy');
      }
    }
  });
}
